import React, { useEffect, useState } from 'react';
import { Menu, X, Camera } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Portfolio',
    href: '#portfolio'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-cream/95 backdrop-blur-sm shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-95">
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center" data-id="element-96">
        <a href="#home" className="flex items-center gap-1 group" data-id="element-97">
          <span className={`font-serif text-2xl tracking-wide transition-colors duration-300 ${isScrolled ? 'text-charcoal' : 'text-white'}`} data-id="element-98">
            photos by <span className="italic" data-id="element-99">tunga</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-100">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm tracking-widest uppercase hover:text-gold transition-colors duration-300 ${isScrolled ? 'text-charcoal' : 'text-white/90'}`} data-id="element-101">
              {link.name}
            </a>)}
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-102">
          {isMobileMenuOpen ? <X className={`w-6 h-6 ${isScrolled ? 'text-charcoal' : 'text-white'}`} data-id="element-103" /> : <Menu className={`w-6 h-6 ${isScrolled ? 'text-charcoal' : 'text-white'}`} data-id="element-104" />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-105">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-cream shadow-lg md:hidden border-t border-gray-100" data-id="element-106">
            <div className="flex flex-col py-8 px-6 gap-6 items-center" data-id="element-107">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-charcoal text-lg font-serif hover:text-gold transition-colors" data-id="element-108">
                  {link.name}
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}